import { useEffect, useState } from 'react';
import {
    useParams,
    useNavigate,
    matchPath,
    useLocation
} from "react-router-dom";

import {
    useGetLanguages,
    useGetCompetitions,
    useGetDisciplines,
    useGetEventUnits,
    useGetRoutes,
    useGetFunctionRoutes
} from "helpers/commonCodes";
import { getURL } from "./utils";


import { getCompetitions, getDisciplines, getEventUnits, getPositions } from 'data/Querys';
import { getSportsCodes } from "data/Querys";
import { useQueries, useQuery, useQueryClient } from 'react-query'
import Loader from 'components/general/Loader';
import NotAvailable from 'components/common/NotAvailable';
import { getLevelRSC, getUnit, getEventRSC, getLongEventRSC } from 'helpers/rsc';
import Label from 'components/general/Label';
import { ALL_URL } from './utils';


export function useUrlFriendlyToParameters() {

    //Get values friendly from URL 
    const { mirs_competition, mirs_rsc, mirs_language, mirs_discipline, mirs_event_rsc, mirs_event, mirs_date, mirs_code, mirs_noc, mirs_medal, mirs_brokenRecords, mirs_gender, mirs_pdftype } = useParams()

    //Get Lenguages from memory 
    const dataLanguage = useGetLanguages()
    let language = dataLanguage?.languages?.find(item => item.description === mirs_language?.toUpperCase())?.lang
    language = language || mirs_language
    language = language?.toUpperCase();

    //Gets Competitions from Memory 
    const dataCompetitions = useGetCompetitions({ mirs_language: language })

    let competition = dataCompetitions?.competitions?.find(item => item.mirs_Description === mirs_competition)?.code
    competition = competition || mirs_competition

    //Get Disciplines from Memory 
    const dataDisciplines = useGetDisciplines({ mirs_competition: competition, mirs_language: language })
    let discipline = dataDisciplines?.disciplines?.find(item => item.mirs_Description === mirs_discipline)?.code
    discipline = discipline || mirs_discipline

    //Get Event Units from memory 
    const dataCC = useGetEventUnits({ mirs_competition: competition, mirs_discipline: discipline, mirs_language: language })


    let event = dataCC?.eventUnits?.find(item => item.mirs_Description === mirs_event_rsc && item.code.charAt(4) !== '-')?.code //No get codes like BKBM-
    event = event || mirs_event_rsc


    let eventFilter = dataCC?.eventUnits?.find(item => item.mirs_Description === mirs_event)?.code
    //eventFilter = eventFilter || mirs_event
    eventFilter = mirs_event



    //duplicates phase and unit get units 
    let startWith = getEventRSC(event)
    let unit = dataCC?.eventUnits?.find(item => item.mirs_ShortDescription === mirs_rsc && item.code.startsWith(startWith) && item.code !== getLongEventRSC(event))?.code
    //let unit = dataCC?.eventUnits?.find(item => item.mirs_ShortDescription === mirs_rsc)?.code

    //Para evitar que falle el programa ya que todo tira de mirs_rsc ponemos el rsc de event o de unit
    unit = unit ? unit : event



    return { mirs_competition: competition, mirs_discipline: discipline, mirs_event_rsc: event, mirs_rsc: unit, mirs_language: language, mirs_event: eventFilter, mirs_date: mirs_date, mirs_code, mirs_noc, mirs_medal, mirs_brokenRecords: mirs_brokenRecords, mirs_gender, mirs_pdftype }
}

export function useParametersToUrlFriendly(paramsURL, path) {
    //Parameters from URL 
    const { mirs_competition, mirs_discipline, mirs_event_rsc, mirs_rsc, mirs_language, mirs_brokenRecords, mirs_gender } = paramsURL

    //Get data Descriptions from Memory 
    const dataLanguage = useGetLanguages()
    const dataCompetitions = useGetCompetitions(paramsURL)
    const dataDisciplines = useGetDisciplines(paramsURL)
    const dataEventUnit = useGetEventUnits(paramsURL);
    const dataRouter = useGetRoutes();

    let language = dataLanguage?.languages?.find(item => item.lang === mirs_language?.toUpperCase())?.description;
    //language = language || mirs_language;
    language = language?.toLowerCase();
    let competition = dataCompetitions?.competitions?.find(item => item.code === mirs_competition)?.mirs_Description

    let discipline = dataDisciplines?.disciplines?.find(item => item.code === mirs_discipline)?.description

    let event = dataEventUnit?.eventUnits?.find(item => item.code === mirs_event_rsc)?.mirs_Description;
    //phase = phase ? phase : mirs_event_rsc;
    let unit = dataEventUnit?.eventUnits?.find(item => item.code === mirs_rsc)?.mirs_ShortDescription
    unit = unit ? unit : mirs_rsc

    let _path = dataRouter?.routes && dataRouter?.routes[path]
    return { mirs_competition: competition, mirs_discipline: discipline, mirs_event_rsc: event, mirs_rsc: unit, mirs_language: language, mirs_path: _path, mirs_brokenRecords: mirs_brokenRecords, mirs_gender }
}

/**
 * Return String URL composed 
 *
 * @paramsURL :  get an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 * @path : path URL
 * 
 * Structure: language/path/discipline/date/rsc 
 */
export function useGetURL(paramsURL, path) {

    // Get Parameters 
    const { mirs_competition, mirs_discipline, mirs_event_rsc, mirs_rsc, mirs_language } = useParametersToUrlFriendly(paramsURL, path)
    let competition = mirs_competition;
    let discipline = mirs_discipline;
    let language = mirs_language;
    const dataRouters = useGetRoutes(language)
    let pathFriendly = dataRouters?.routes[path]

    let paramsNavigator = useParams()
    //let competition = (paramsURL.mirs_competition !== undefined) ? `${paramsURL.mirs_competition}` : `${process.env.REACT_APP_DEFAULT_COMPETITION}`;
    //let language = (paramsURL.mirs_language !== undefined) ? `${paramsURL.mirs_language}` : `${process.env.REACT_APP_DEFAULT_LANGUAGE}`;
    //let discipline = (paramsURL.mirs_discipline !== undefined) ? `${paramsURL.mirs_discipline}` : '';
    let date = (paramsURL.mirs_date !== undefined && paramsURL.mirs_date !== '') ? `${paramsURL.mirs_date}` : '';
    let event = (paramsURL.mirs_event !== undefined && paramsURL.mirs_event !== "") ? `${paramsURL.mirs_event}` : '';
    let eventRsc = (paramsURL.mirs_event_rsc !== undefined && paramsURL.mirs_event_rsc !== '') ? `${paramsURL.mirs_event_rsc}` : '';
    let rsc = (paramsURL.mirs_rsc !== undefined && paramsURL.mirs_rsc !== '') ? `${paramsURL.mirs_rsc}` : '';
    let code = (paramsURL.mirs_code !== undefined && paramsURL.mirs_code !== '') ? `${paramsURL.mirs_code}` : '';
    let noc = (paramsURL.mirs_noc !== undefined && paramsURL.mirs_noc !== '') ? `${paramsURL.mirs_noc}` : '';
    let medal = (paramsURL.mirs_medal !== undefined && paramsURL.mirs_medal !== '') ? `${paramsURL.mirs_medal}` : '';
    let gender = (paramsURL.mirs_gender !== undefined && paramsURL.mirs_gender !== '') ? `${paramsURL.mirs_gender}` : '';

    let pdftype = (paramsURL.mirs_pdftype !== undefined && paramsURL.mirs_pdftype !== '') ? `${paramsURL.mirs_pdftype}` : '';


    let url = ""
    let brokenRecords = (paramsURL.mirs_brokenRecords !== undefined && paramsURL.mirs_brokenRecords !== '') ? `${paramsURL.mirs_brokenRecords}` : '';

    //Revisar porque esta esto......
    event = event ? "/" + event : mirs_event_rsc ? mirs_event_rsc : ''

    let isFriendly = true

    if (paramsNavigator.mirs_language === paramsURL.mirs_language) {
        //Navigation By Code
        //return getURL(paramsURL, path)

        competition = (paramsURL.mirs_competition !== undefined) ? paramsURL.mirs_competition : '';
        language = (paramsURL.mirs_language !== undefined) ? paramsURL.mirs_language : '';
        discipline = (paramsURL.mirs_discipline !== undefined) ? paramsURL.mirs_discipline : '';
        event = ''// (paramsURL.mirs_event !== undefined) ? `${paramsURL.mirs_event}` : '';
        //rsc = (paramsURL.mirs_rsc !== undefined) ? paramsURL.mirs_rsc : '';

        isFriendly = false;
        pathFriendly = path
    }

    if (path === 'competitionstatus' || path === 'hearingschedule') {
        url = "/" + competition + "/" + language + "/" + pathFriendly + "/" + discipline
    }

    if (path === 'competitionschedule') {
        url = "/" + competition + "/" + language + "/" + pathFriendly
    }

    if (path === 'disciplines') {
        url = competition + language + pathFriendly
    }

    if (path === 'records') {
        url = "/" + competition + "/" + language + "/" + pathFriendly
        if (discipline) {
            url += "/" + discipline;
            if (event)
                url += event;
        }
        if (noc) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
            (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            url += "/" + noc
        }
        if (brokenRecords) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
            (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            (noc) ? url += "/" + noc : url += "/" + ALL_URL.ALL_NOC;
            url += "/" + brokenRecords
        }
    }

    if (path === 'schedule') {
        //url = "/" + competition + "/" + language + "/" + pathFriendly + "/" + discipline + "/" + date + event
        url = "/" + competition + "/" + language + "/" + pathFriendly;
        (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
        (date) ? url += "/" + date : url += "/" + ALL_URL.ALL_DAYS;
        (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
    }

    if (path === 'schedulebynoc' || path === 'entriesbynoc' || path === 'medallistsbynoc' || path === 'profilebynoc') {
        url = "/" + competition + "/" + language + "/" + pathFriendly + "/" + noc
    }






    if (path === 'results') {
        rsc = (mirs_rsc === rsc || mirs_rsc === undefined) || !isFriendly ? rsc : mirs_rsc;
        rsc = (rsc) ? "/" + rsc : ''
        eventRsc = (mirs_event_rsc === eventRsc || mirs_event_rsc === undefined) || !isFriendly ? eventRsc : mirs_event_rsc;
        //path = (mirs_path === path || mirs_path === undefined) ? path : mirs_path;
        if (isFriendly) {
            url = "/" + competition + "/" + language + "/" + pathFriendly + "/" + discipline + "/" + eventRsc + rsc
        } else {
            url = "/" + competition + "/" + language + "/" + pathFriendly + "/" + discipline + rsc
        }
    }


    if (
        path === 'pool'
        || path === 'bracket'
        || path === 'ranking'
    ) {
        rsc = (mirs_rsc === rsc || mirs_rsc === undefined) || !isFriendly ? rsc : mirs_rsc;
        rsc = (rsc) ? "/" + rsc : ''
        eventRsc = (mirs_event_rsc === eventRsc || mirs_event_rsc === undefined) || !isFriendly ? eventRsc : mirs_event_rsc;

        if (isFriendly) {
            url = "/" + competition + "/" + language + "/" + pathFriendly + "/" + discipline + "/" + eventRsc
        } else {
            url = "/" + competition + "/" + language + "/" + pathFriendly + "/" + discipline + rsc
        }


    }

    if (path === 'bios') {
        url = "/" + competition + "/" + language + "/" + pathFriendly + "/" + code
    }

    if (path === 'liveIndividual'
        || path === 'liveTeam'
        || path === 'placings') {
        url = "/" + competition + "/" + language + "/" + pathFriendly + "/" + discipline
    }

    if (path === 'medal' || path === 'multimedallists') {
        url = "/" + competition + "/" + language + "/" + pathFriendly;
        (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
        (noc) ? url += "/" + noc : url += "/" + ALL_URL.ALL_NOC;
        if (gender) {
            url += "/" + gender
        }
    }

    if (path === 'medallists') {
        url = "/" + competition + "/" + language + "/" + pathFriendly;
        if (discipline) {
            url += "/" + discipline;
            if (event)
                url += "/" + event;
        }
        if (noc) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
            (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            url += "/" + noc
        }
        if (medal) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
            (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            (noc) ? url += "/" + noc : url += ALL_URL.ALL_NOC;
            url += "/" + medal
        }
        if (date) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
            (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            (noc) ? url += "/" + noc : url += ALL_URL.ALL_NOC;
            (medal) ? url += "/" + medal : url += ALL_URL.ALL_MEDAL;
            url += "/" + date
        }
    }

    if (path === 'athletes') {
        url = "/" + competition + "/" + language + "/" + pathFriendly;
        if (discipline) {
            url += "/" + discipline
            if (event) {
                url += "/" + event
            }
        }
        if (noc) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            if (discipline) {
                url += "/" + discipline
            } else {
                url += "/" + ALL_URL.ALL_DISC;
            }
            url += "/" + noc
        }
    }

    if (path === 'teams') {
        url = "/" + competition + "/" + language + "/" + pathFriendly;
        if (discipline) {
            url += "/" + discipline;
            if (noc) {
                url += "/" + noc
            }
            if (event) {
                url += "/" + event;
            }
        } else {
            if (noc) {
                url += "/" + ALL_URL.ALL_DISC + "/" + noc;
            }
        }
    }

    if (path === 'coaches') {
        url = "/" + competition + "/" + language + "/" + pathFriendly;
        if (discipline) {
            url += "/" + discipline;
            if (event)
                url += "/" + event;
        }
        if (noc) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
            //(event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            url += "/" + noc
        }
    }

    if (path === 'technicalofficials') {
        url = "/" + competition + "/" + language + "/" + pathFriendly;
        if (discipline) {
            url += "/" + discipline;
            if (event)
                url += "/" + event;
        }
        if (noc) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
            //       (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            url += "/" + noc
        }
    }

    if (path === 'horses') {
        url = "/" + competition + "/" + language + "/" + pathFriendly;
        if (discipline) {
            url += "/" + discipline;
            if (event)
                url += "/" + event;
        }
        if (noc) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
            // (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            url += "/" + noc
        }
    }
    if (path === 'entries') {
        url = "/" + competition + "/" + language + "/" + pathFriendly;
        if (discipline) {
            url += "/" + discipline;
            if (event)
                url += "/" + event;
        }
        if (noc) {
            url = "/" + competition + "/" + language + "/" + pathFriendly;
            (discipline) ? url += "/" + discipline : url += "/" + ALL_URL.ALL_DISC;
            (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            url += "/" + noc
        }
    }


    if (path === 'noclist') {
        url = "/" + competition + "/" + language + "/" + pathFriendly
    }

    if (path === 'reports') {
        url = "/" + competition + "/" + language + "/" + pathFriendly
        if (discipline) {
            url += "/" + discipline
            if (event) { url += "/" + event }
        }
        if (pdftype) {
            //"ALL_PDFs": "all-pdfs"
            (event) ? url += "/" + event : url += "/" + ALL_URL.ALL_EVENT;
            url += "/" + pdftype
        }




    }

    return (url)
}

export const useNavigateTo = (paramsURL, shouldNavigate, setShouldNavigate, path) => {
    //Parametros from URL no manipulated
    const urlParameters = useParams()
    const navigate = useNavigate()
    let url = useGetURL(paramsURL, path)

    const dataLanguage = useGetLanguages()
    let language = dataLanguage?.languages?.find(item => item.lang === paramsURL.mirs_language?.toUpperCase())?.lang
    language = language?.toUpperCase();


    //Si estamos sin traducciones la URL tiene codigos
    if (language && (urlParameters.mirs_language === paramsURL.mirs_language)) {
        url = getURL(paramsURL, path)
    }

    useEffect(() => {
        if (shouldNavigate) {
            navigate(url)
            setShouldNavigate(false)
        }
    }, [shouldNavigate])
};

export const useNavigateTo2 = (url, shouldNavigate, setShouldNavigate) => {


    const navigate = useNavigate()
    useEffect(() => {
        if (shouldNavigate) {
            navigate(url)
            setShouldNavigate(false)
        }
    }, [shouldNavigate])
};

export function useLoadCCData(params, loaded, setLoaded) {

    const labelSwimOff = Label({ data: "SwimOff" })
    const mirs_competition = params.mirs_competition
    const mirs_language = params.mirs_language
    const mirs_discipline = params.mirs_discipline
    let paramsToParameter;
    //const mirs_event_rsc = params.mirs_event_rsc
    // const mirs_rsc = params.mirs_rsc
    //const mirs_date = params.mirs_date
    // const mirs_event = params.mirs_event



    const dataLanguage = useGetLanguages()
    let language = dataLanguage?.languages?.find(item => item.description === mirs_language?.toUpperCase())?.lang
    language = language || mirs_language
    let mlanguage = language?.toUpperCase();

    const { isError: isErrorCompetitions, isLoading: isLoadingCompetitions, data: dataCompetitions } = useQuery(
        {
            queryKey: ['CC_Competitions', mlanguage?.toUpperCase()],
            queryFn: getCompetitions,
            refetchInterval: 0,
            staleTime: Infinity,
            refetchIntervalInBackground: false,
            notifyOnChangeProps: ['data', 'error'],
            enabled: !!mlanguage
        });



    let mcompetition
    if (dataCompetitions?.competitions) {
        dataCompetitions?.competitions?.forEach((dt) => {
            dt.mirs_Description = dt?.description?.replace(/ /g, "_");
        });
        mcompetition = dataCompetitions?.competitions?.find(item => item.mirs_Description === mirs_competition)?.code
        mcompetition = mcompetition || mirs_competition
    }




    const { isError: isErrorDisciplines, isLoading: isLoadingDisciplines, data: dataDisciplines } = useQuery(
        {
            queryKey: ['CC_Disciplines', mcompetition, mlanguage?.toUpperCase()],
            queryFn: getDisciplines,
            refetchInterval: 0,
            staleTime: Infinity,
            refetchIntervalInBackground: false,
            notifyOnChangeProps: ['data', 'error'],
            enabled: !!mcompetition
        });

    dataDisciplines?.disciplines?.forEach((dt) => {
        dt.mirs_Description = dt?.description?.replace(/ /g, "_");
    });

    let mdiscipline = dataDisciplines?.disciplines?.find(item => item.mirs_Description === mirs_discipline)?.code
    mdiscipline = mdiscipline || mirs_discipline




    //Read disciplines from memory 

    //Convert urlfriendly in codes




    let queryArray = [];
    mdiscipline && queryArray.push({
        queryKey: ['CC_EventUnits', mcompetition, mdiscipline, mlanguage?.toUpperCase()],
        queryFn: getEventUnits,
        refetchInterval: 0,
        //cacheTime: 5000,
        staleTime: Infinity,
        refetchIntervalInBackground: false,
        notifyOnChangeProps: ['data', 'error'],
        enabled: !!mdiscipline
    })



    //Load data from SportCodes CC file
    mdiscipline && queryArray.push({
        queryKey: ['CC_Positions', mcompetition, mdiscipline, mlanguage?.toUpperCase()],
        queryFn: getPositions,
        refetchInterval: 0,
        staleTime: Infinity,
        refetchIntervalInBackground: false,
        retry: false,
        suspense: false,
        enabled: !!mdiscipline
    })




    //Load data from SportCodes CC file
    mdiscipline && queryArray.push({
        queryKey: ['SportCodes', mcompetition, mlanguage?.toUpperCase()],
        queryFn: getSportsCodes,
        refetchInterval: 0,
        staleTime: Infinity,
        refetchIntervalInBackground: false,
        retry: false,
        suspense: false,
        enabled: !!mcompetition
    })



    const results = useQueries(queryArray);
    const isLoading = results.some(result => result.isLoading)
    const isError = results.some(result => result.isError)




    const dataEventUnits = useGetEventUnits({
        mirs_competition: mcompetition,
        mirs_discipline: mdiscipline,
        mirs_language: mlanguage
    })
    useEffect(() => {
        if (dataEventUnits?.eventUnits) {
            setLoaded(true)
        }
    }, [dataEventUnits?.eventUnits])



    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }


    dataEventUnits?.eventUnits?.forEach((dt) => {
        let unit = getLevelRSC(dt.code) === "UNIT" ? "-" + getUnit(dt?.code) : ""
        dt.mirs_Description = dt?.description?.replace(/ /g, "_") + unit;
        dt.mirs_ShortDescription = dt?.shortDescription?.replace(/ /g, "_") + unit;
        if (getLevelRSC(dt.code) === "PHASE") {
            let phaseFilter = dataEventUnits?.eventUnits?.find(item => item.code === dt.code.substring(0, dt.code.length - 10) + "RR--------")
            if (!phaseFilter) {
                let h = { ...dt }
                h.order = Number(h.order) - 0.5
                h.shortDescription = dt.shortDescription + " " + labelSwimOff
                h.longDescription = dt.longDescription + " " + labelSwimOff
                h.description = dt.description + " " + labelSwimOff
                h.code = dt.code.substring(0, dt.code.length - 10) + "RR--------";
                h.mirs_Description = h?.description?.replace(/ /g, "_");
                h.mirs_ShortDescription = h?.shortDescription?.replace(/ /g, "_");
                if (mirs_discipline === 'SWM') { dataEventUnits?.eventUnits.push(h) }

            }
        }
    });



    /*
        if (execute) {
            if (!loaded) {
                setLoaded(true)
            }
        }
    */

    paramsToParameter = {
        mirs_language: mlanguage,
        mirs_competition: mcompetition,
        mirs_discipline: mdiscipline,
    }



    return (paramsToParameter)

}


export function useGetPath() {
    const getRouter = useGetFunctionRoutes();
    const location = useLocation();
    return function (language) {
        const dataRouters = getRouter(language)
        var res = location.pathname?.split("/");
        let mpath = res[3]
        let pathUrl = location.pathname;


        //translate urlfriendly or path 
        let pathSchedule = mpath === 'schedule' ? mpath : dataRouters?.routes?.schedule
        let pathResult = mpath === 'results' ? mpath : dataRouters?.routes?.results
        let pathPool = mpath === 'pool' ? mpath : dataRouters?.routes?.pool
        let pathBracket = mpath === 'bracket' ? mpath : dataRouters?.routes?.bracket
        let pathRanking = mpath === 'ranking' ? mpath : dataRouters?.routes?.ranking
        let pathMedal = mpath === 'medal' ? mpath : dataRouters?.routes?.medal
        let pathMedallists = mpath === 'medallists' ? mpath : dataRouters?.routes?.medallists
        let pathMultiMedallists = mpath === 'multimedallists' ? mpath : dataRouters?.routes?.multimedallists
        let pathCompetitionStatus = mpath === 'competitionstatus' ? mpath : dataRouters?.routes?.competitionstatus
        let pathHearingSchedule = mpath === 'hearingschedule' ? mpath : dataRouters?.routes?.hearingschedule
        let pathCompetitionschedule = mpath === 'competitionschedule' ? mpath : dataRouters?.routes?.competitionschedule
        let pathRecords = mpath === 'records' ? mpath : dataRouters?.routes?.records
        let pathDisciplineRecords = mpath === 'disciplinerecords' ? mpath : dataRouters?.routes?.disciplineRecords
        let pathBio = mpath === 'bios' ? mpath : dataRouters?.routes?.bios
        let pathLiveIndividual = mpath === 'liveIndividual' ? mpath : dataRouters?.routes?.liveIndividual
        let pathLiveTeam = mpath === 'liveTeam' ? mpath : dataRouters?.routes?.liveTeam
        let pathAthletes = mpath === 'athletes' ? mpath : dataRouters?.routes?.athletes
        let pathTodayMatches = mpath === 'todayMatches' ? mpath : dataRouters?.routes?.todayMatches
        let pathTodayAthMatches = mpath === 'todayAthMatches' ? mpath : dataRouters?.routes?.todayAthMatches
        let pathTodayTeamMatches = mpath === 'todayTeamMatches' ? mpath : dataRouters?.routes?.todayTeamMatches
        let pathPlacing = mpath === 'placings' ? mpath : dataRouters?.routes?.placing
        let pathReports = mpath === 'reports' ? mpath : dataRouters?.routes?.reports
        let pathTeams = mpath === 'teams' ? mpath : dataRouters?.routes?.teams
        let pathCoaches = mpath === 'coaches' ? mpath : dataRouters?.routes?.coaches
        let pathTechnicalOfficials = mpath === 'technicalofficials' ? mpath : dataRouters?.routes?.technicalofficials
        let pathHorses = mpath === 'horses' ? mpath : dataRouters?.routes?.horses
        let pathEntries = mpath === 'entries' ? mpath : dataRouters?.routes?.entries
        let pathNocList = mpath === 'noclist' ? mpath : dataRouters?.routes?.noclist

        let pathScheduleByNoc = mpath === 'schedulebynoc' ? mpath : dataRouters?.routes?.schedulebynoc
        let pathEntriesByNoc = mpath === 'entriesbynoc' ? mpath : dataRouters?.routes?.entriesbynoc
        let pathMedallistsByNoc = mpath === 'medallistsbynoc' ? mpath : dataRouters?.routes?.medallistsbynoc
        let pathProfileByNoc = mpath === 'profilebynoc' ? mpath : dataRouters?.routes?.profilebynoc




        //check by path or pathfriendly 
        let isSchedule = matchPath({ path: `/:mirs_competition/:mirs_language/${pathSchedule}/*` }, pathUrl);
        //let isResult = useMatch({ path: pathUrl, end: true });
        let isResult = matchPath({ path: `/:mirs_competition/:mirs_language/${pathResult}/*` }, pathUrl);
        let isPool = matchPath({ path: `/:mirs_competition/:mirs_language/${pathPool}/*` }, pathUrl);
        let isBracket = matchPath({ path: `/:mirs_competition/:mirs_language/${pathBracket}/*` }, pathUrl);
        let isRanking = matchPath({ path: `/:mirs_competition/:mirs_language/${pathRanking}/*` }, pathUrl);
        let isCompetitionStatus = matchPath({ path: `/:mirs_competition/:mirs_language/${pathCompetitionStatus}/*` }, pathUrl);
        let isHearingSchedule = matchPath({ path: `/:mirs_competition/:mirs_language/${pathHearingSchedule}/*` }, pathUrl);
        let isMedal = matchPath({ path: `/:mirs_competition/:mirs_language/${pathMedal}/*` }, pathUrl);
        let isMedallists = matchPath({ path: `/:mirs_competition/:mirs_language/${pathMedallists}/*` }, pathUrl);
        let isMultiMedallists = matchPath({ path: `/:mirs_competition/:mirs_language/${pathMultiMedallists}/*` }, pathUrl);
        let isAthletes = matchPath({ path: `/:mirs_competition/:mirs_language/${pathAthletes}/*` }, pathUrl);
        let isTeams = matchPath({ path: `/:mirs_competition/:mirs_language/${pathTeams}/*` }, pathUrl);
        let isCoaches = matchPath({ path: `/:mirs_competition/:mirs_language/${pathCoaches}/*` }, pathUrl);
        let isTechnicalOfficials = matchPath({ path: `/:mirs_competition/:mirs_language/${pathTechnicalOfficials}/*` }, pathUrl);
        let isHorses = matchPath({ path: `/:mirs_competition/:mirs_language/${pathHorses}/*` }, pathUrl);
        let isEntries = matchPath({ path: `/:mirs_competition/:mirs_language/${pathEntries}/*` }, pathUrl);
        let isCompetitionSchedule = matchPath({ path: `/:mirs_competition/:mirs_language/${pathCompetitionschedule}/*` }, pathUrl);
        let isNocList = matchPath({ path: `/:mirs_competition/:mirs_language/${pathNocList}/*` }, pathUrl);
        let isRecords = matchPath({ path: `/:mirs_competition/:mirs_language/${pathRecords}/*` }, pathUrl);
        let isScheduleByNoc = matchPath({ path: `/:mirs_competition/:mirs_language/${pathScheduleByNoc}/*` }, pathUrl);
        let isEntriesByNoc = matchPath({ path: `/:mirs_competition/:mirs_language/${pathEntriesByNoc}/*` }, pathUrl);
        let isMedallistsByNoc = matchPath({ path: `/:mirs_competition/:mirs_language/${pathMedallistsByNoc}/*` }, pathUrl);
        let isProfileByNoc = matchPath({ path: `/:mirs_competition/:mirs_language/${pathProfileByNoc}/*` }, pathUrl);

        return (
            {
                pathFriendly: {
                    pathSchedule: pathSchedule,
                    pathResult: pathResult,
                    pathPool: pathPool,
                    pathBracket: pathBracket,
                    pathRanking: pathRanking,
                    pathCompetitionStatus: pathCompetitionStatus,
                    pathHearingSchedule: pathHearingSchedule,
                    pathMedal: pathMedal,
                    pathMedallists: pathMedallists,
                    pathMultiMedallists: pathMultiMedallists,
                    pathScheduleByNoc: pathScheduleByNoc,
                    pathCompetitionschedule: pathCompetitionschedule,
                    pathRecords: pathRecords,
                    pathDisciplineRecords: pathDisciplineRecords,
                    pathBio: pathBio,
                    pathLiveIndividual: pathLiveIndividual,
                    pathLiveTeam: pathLiveTeam,
                    pathAthletes: pathAthletes,
                    pathTodayMatches: pathTodayMatches,
                    pathTodayAthMatches: pathTodayAthMatches,
                    pathTodayTeamMatches: pathTodayTeamMatches,
                    pathNocList: pathNocList,
                    pathPlacing: pathPlacing,
                    pathReports: pathReports,
                    pathTeams: pathTeams,
                    pathCoaches: pathCoaches,
                    pathTechnicalOfficials: pathTechnicalOfficials,
                    pathHorses: pathHorses,
                    pathEntries: pathEntries,
                    pathEntriesByNoc: pathEntriesByNoc,
                    pathMedallistsByNoc: pathMedallistsByNoc,
                    pathProfileByNoc: pathProfileByNoc
                },

                url: {
                    isResult: isResult,
                    isPool: isPool,
                    isBracket: isBracket,
                    isRanking: isRanking,
                    isSchedule: isSchedule,
                    isCompetitionStatus: isCompetitionStatus,
                    isHearingSchedule: isHearingSchedule,
                    isMedal: isMedal,
                    isMedallists: isMedallists,
                    isMultiMedallists: isMultiMedallists,
                    isAthletes: isAthletes,
                    isTeams: isTeams,
                    isCoaches: isCoaches,
                    isHorses: isHorses,
                    isEntries: isEntries,
                    isCompetitionSchedule: isCompetitionSchedule,
                    isAthletes: isAthletes,
                    isTechnicalOfficials: isTechnicalOfficials,
                    isNocList: isNocList,
                    isRecords: isRecords,
                    isEntriesByNoc: isEntriesByNoc,
                    isMedallistsByNoc, isMedallistsByNoc,
                    isProfileByNoc, isProfileByNoc,
                    isScheduleByNoc: isScheduleByNoc

                }

            }
        );
    }
}

export function GetRealPath() {
    const obj = useGetPath();
    return function (language) {
        const objUrl = obj(language);
        if (objUrl.url.isResult) return ("results")
        if (objUrl.url.isPool) return ("pool")
        if (objUrl.url.isBracket) return ("bracket")
        if (objUrl.url.isRanking) return ("ranking")
        if (objUrl.url.isSchedule) return ("schedule")
        if (objUrl.url.isCompetitionStatus) return ("competitionstatus")
        if (objUrl.url.isHearingSchedule) return ("hearingschedule")
        if (objUrl.url.isMedal) return ("medal")
        if (objUrl.url.isMedallists) return ("medallists")
        if (objUrl.url.isMultiMedallists) return ("multimedallists")
        if (objUrl.url.isCompetitionSchedule) return ("competitionschedule")
        if (objUrl.url.isAthletes) return ("athletes")
        if (objUrl.url.isTeams) return ("teams")
        if (objUrl.url.isCoaches) return ("coaches")
        if (objUrl.url.isTechnicalOfficials) return ("technicalofficials")
        if (objUrl.url.isHorses) return ("horses")
        if (objUrl.url.isNocList) return ("noclist")
        if (objUrl.url.isEntries) return ("entries")
        if (objUrl.url.isRecords) return ("records")
        if (objUrl.url.isEntriesByNoc) return ("entriesbynoc")
        if (objUrl.url.isMedallistsByNoc) return ("medallistsbynoc")
        if (objUrl.url.isProfileByNoc) return ("profilebynoc")
        if (objUrl.url.isScheduleByNoc) return ("schedulebynoc")

    }
}

